/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconHome2 = createReactComponent("home-2", "IconHome2", [
  ["path", { d: "M5 12l-2 0l9 -9l9 9l-2 0", key: "svg-0" }],
  ["path", { d: "M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7", key: "svg-1" }],
  ["path", { d: "M10 12h4v4h-4z", key: "svg-2" }]
]);

export { IconHome2 as default };
//# sourceMappingURL=IconHome2.js.map
